ceregoCommon.factory('TimezonesResource', ['$resource', ($resource) ->
  $resource "", {},
    query:
      method: 'GET'
      isArray: false
      url: APIRoutes.v2_timezones_path()
])
